var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarkerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 8.66536C7.10489 8.66536 8.00033 7.76993 8.00033 6.66536C8.00033 5.5608 7.10489 4.66536 6.00033 4.66536C4.89576 4.66536 4.00033 5.5608 4.00033 6.66536C4.00033 7.76993 4.89576 8.66536 6.00033 8.66536Z",
    stroke: "#475467",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 14.6654C8.66699 11.9987 11.3337 9.61088 11.3337 6.66536C11.3337 3.71985 8.94584 1.33203 6.00033 1.33203C3.05481 1.33203 0.666992 3.71985 0.666992 6.66536C0.666992 9.61088 3.33366 11.9987 6.00033 14.6654Z",
    stroke: "#475467",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerIcon);
export default __webpack_public_path__ + "static/media/map-marker-icon.d3f5e6c12fbce370298d9784fa2921a4.svg";
export { ForwardRef as ReactComponent };